
export default {
    async notify(data) {
      console.log(data);
    },
}